import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import DoctorSquareCallbackPage from './DoctorSquareCallbackPage.js';

export default WithGASetup(DoctorSquareCallbackPage, AuthContext);
